/* Advertorial Landing — interactivity + Shopify cart handoff */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.advInit === '1') return;
    root.dataset.advInit = '1';

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    function formatMoney(cents, format) {
      var fmt = format || moneyFormat;
      function defaultTo(v, d) { return v == null || v === '' ? d : v; }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cts = parts[1] ? decimal + parts[1] : '';
        return dollars + cts;
      }
      var value = '';
      var match = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
      var placeholder = match ? match[1] : 'amount';

      switch (placeholder) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    /* Smooth scroll */
    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-scroll-to]');
      if (!trigger) return;
      var target = root.querySelector('[data-anchor="' + trigger.dataset.scrollTo + '"]');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    /* Sticky bar */
    var hero = root.querySelector('.adv-hero');
    var offer = root.querySelector('[data-anchor="offer"]');
    var stickyBar = root.querySelector('#adv-sticky-bar');

    if (hero && offer && stickyBar) {
      var onScroll = function () {
        var heroBottom = hero.getBoundingClientRect().bottom;
        var offerTop = offer.getBoundingClientRect().top;
        var show = heroBottom < 0 && offerTop > window.innerHeight * 0.35;
        stickyBar.classList.toggle('show', show);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Quiz */
    var quizOpts = root.querySelectorAll('.adv-quiz-opt');
    var quizResult = root.querySelector('.adv-quiz-result');
    quizOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        quizOpts.forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        if (quizResult) quizResult.textContent = opt.dataset.result || '';
      });
    });

    /* Interactive demo */
    var demoDataEl = root.querySelector('#adv-demo-data');
    var demoPage = root.querySelector('#adv-demo-page');

    if (demoDataEl && demoPage) {
      var demoData = [];
      try { demoData = JSON.parse(demoDataEl.textContent); } catch (err) { demoData = []; }

      var demoTabs = root.querySelectorAll('.adv-demo-tab');
      var demoIndex = 0;

      var escapeHtml = function (str) {
        var d = document.createElement('div');
        d.textContent = str == null ? '' : str;
        return d.innerHTML;
      };

      var renderDemo = function () {
        var d = demoData[demoIndex];
        if (!d) return;
        var html = '<div class="adv-tag">' + escapeHtml(d.tag) + '</div>' +
                   '<h3>' + escapeHtml(d.q) + '</h3>';

        if (d.type === 'circle' && Array.isArray(d.opts)) {
          html += '<div class="adv-circle-opts">' + d.opts.map(function (o) {
            return '<button type="button" class="adv-circle-opt">' + escapeHtml(String(o).trim()) + '</button>';
          }).join('') + '</div>';
        } else if (d.type === 'write') {
          html += '<input class="adv-write-line" placeholder="Type her answer here...">';
          html += '<input class="adv-write-line" placeholder="Type your answer here...">';
        } else {
          html += '<div class="adv-draw-area">\uD83D\uDD8D\uFE0F imagine her drawing here</div>';
        }

        demoPage.innerHTML = html;

        demoPage.querySelectorAll('.adv-circle-opt').forEach(function (o) {
          o.addEventListener('click', function () { o.classList.toggle('picked'); });
        });

        demoTabs.forEach(function (t, i) { t.classList.toggle('active', i === demoIndex); });
      };

      demoTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          demoIndex = parseInt(tab.dataset.i, 10) || 0;
          renderDemo();
        });
      });

      var prevBtn = root.querySelector('#adv-demo-prev');
      var nextBtn = root.querySelector('#adv-demo-next');
      if (nextBtn) nextBtn.addEventListener('click', function () {
        demoIndex = (demoIndex + 1) % demoData.length; renderDemo();
      });
      if (prevBtn) prevBtn.addEventListener('click', function () {
        demoIndex = (demoIndex - 1 + demoData.length) % demoData.length; renderDemo();
      });

      renderDemo();
    }

    /* FAQ accordion */
    root.querySelectorAll('.adv-faq-item').forEach(function (item) {
      var q = item.querySelector('.adv-faq-q');
      var a = item.querySelector('.adv-faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        root.querySelectorAll('.adv-faq-item').forEach(function (i) {
          i.classList.remove('open');
          var ans = i.querySelector('.adv-faq-a');
          var btn = i.querySelector('.adv-faq-q');
          if (ans) ans.style.maxHeight = null;
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Bundle selection + checkout */
    var bundles = root.querySelectorAll('.adv-bundle');
    var variantInput = root.querySelector('#adv-variant-input');
    var qtyInput = root.querySelector('#adv-quantity-input');
    var returnInput = root.querySelector('#adv-return-input');
    var totalEl = root.querySelector('#adv-order-total');
    var stickyPriceEl = root.querySelector('#adv-sticky-price');
    var summaryQty = root.querySelector('#adv-summary-qty');
    var savingsRow = root.querySelector('#adv-savings-row');
    var savingsEl = root.querySelector('#adv-savings');
    var basePrice = parseInt(root.dataset.basePrice, 10) || 0;

    function selectBundle(bundle) {
      bundles.forEach(function (b) { b.classList.remove('selected'); });
      bundle.classList.add('selected');

      var qty = parseInt(bundle.dataset.quantity, 10) || 1;
      var total = parseInt(bundle.dataset.total, 10) || 0;
      var variantId = bundle.dataset.variant;
      var discount = (bundle.dataset.discount || '').trim();
      var compare = basePrice * qty;
      var saved = compare - total;

      if (variantInput && variantId) variantInput.value = variantId;
      if (qtyInput) qtyInput.value = qty;
      if (returnInput) {
        returnInput.value = discount
          ? '/checkout?discount=' + encodeURIComponent(discount)
          : '/checkout';
      }

      var formatted = formatMoney(total);
      if (totalEl) totalEl.textContent = formatted;
      if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      if (summaryQty) summaryQty.textContent = '\u00D7 ' + qty;

      if (savingsRow && savingsEl) {
        if (saved > 0) {
          savingsRow.hidden = false;
          savingsEl.textContent = '\u2212' + formatMoney(saved);
        } else {
          savingsRow.hidden = true;
        }
      }
    }

    bundles.forEach(function (bundle) {
      bundle.addEventListener('click', function () { selectBundle(bundle); });
    });

    var preselected = root.querySelector('.adv-bundle.selected') || bundles[0];
    if (preselected) selectBundle(preselected);

    /* Checkout submit */
    var form = root.querySelector('#adv-buy-form');
    var buyBtn = root.querySelector('#adv-buy-btn');

    if (form && buyBtn) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();

        var originalLabel = buyBtn.textContent;
        buyBtn.disabled = true;
        buyBtn.textContent = 'Taking you to checkout...';

        var body = {
          items: [{
            id: parseInt(variantInput.value, 10),
            quantity: parseInt(qtyInput.value, 10) || 1
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add-to-cart failed');
            return res.json();
          })
          .then(function () {
            window.location.href = returnInput ? returnInput.value : '/checkout';
          })
          .catch(function () {
            buyBtn.disabled = false;
            buyBtn.textContent = originalLabel;
            form.submit();
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.adv').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.adv');
    if (el) { el.dataset.advInit = ''; init(el); }
  });
})();
